import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';

import { Modal, FormLayout, DropZone, Button, ChoiceList, ButtonGroup, Tabs } from '@shopify/polaris';
import { tAttribute } from '@utils';

import AutocompleteSearch from '@presentational/AutocompleteSearch';
import ImageDropZone from '@presentational/ImageDropZone';
import BasicTextField from '@presentational/BasicTextField';

const propTypes = {
  collectionBaseURL: PropTypes.string.isRequired,
  formikProps: PropTypes.object.isRequired,
  resourceTypes: PropTypes.object.isRequired,

  handleImageDrop: PropTypes.func.isRequired,
  handleImageRemove: PropTypes.func.isRequired,

  fetchCollectionURL: PropTypes.string.isRequired,
  fetchProductURL: PropTypes.string.isRequired,
}

const defaultProps = {

}

const BannerB2BForm = (props) => {
  const { formikProps, resourceTypes } = props;

  const [selectedSource, setSelectedSource] = useState([ props.resourceTypes.COLLECTION ]);
  const handleSourceChange = useCallback((value) => setSelectedSource(value), []);

  const handleShopifyResourceSelection = (value, item) => {
    const url = selectedSource == resourceTypes.COLLECTION ? `${props.collectionBaseURL}/${item.handle}` : item.onlineStoreUrl;
    formikProps.setFieldValue("b2b_url", url)
  }

  return (
  <FormLayout>
      <ChoiceList
        title="Vincular a:"
        choices={[
          {label: 'Shopify Collection', value: resourceTypes.COLLECTION },
          {label: 'Shopify Product', value: resourceTypes.PRODUCT },
        ]}
        selected={ selectedSource }
        onChange={handleSourceChange}
      />
      { selectedSource == resourceTypes.COLLECTION &&
        <AutocompleteSearch
          placeholder="Buscar collection..."
          apiURL={ props.fetchCollectionURL }
          onSelectionCallback={ handleShopifyResourceSelection }
          itemLabelAccessor="title"
          itemValueAccessor="id"
        />
      }
      { selectedSource == resourceTypes.PRODUCT &&
        <AutocompleteSearch
          placeholder="Buscar producto..."
          apiURL={ props.fetchProductURL }
          onSelectionCallback={ handleShopifyResourceSelection }
          itemLabelAccessor="title"
          itemValueAccessor="id"
        />
      }
      
      <BasicTextField
        name="b2b_url"
        label={ tAttribute("banner", "url") }
        placeholder="https://www.store.com/some-url?utm_source=banners&utm_medium=xyz&utm_campaign=CampaignName"
        handleChange={ (value, id) =>  formikProps.setFieldValue(id, value) }
        values={ formikProps.values }
        errors={ formikProps.errors }
      />

      <BasicTextField
        name="b2b_alt"
        placeholder="Promociones de temporada"
        label={ tAttribute("banner", "alt") }
        handleChange={ (value, id) => formikProps.setFieldValue(id, value) }
        values={ formikProps.values }
        errors={ formikProps.errors }
      />

      <ImageDropZone
        onDrop={ (_dropFiles, acceptedFiles, _rejectedFiles) => props.handleImageDrop(acceptedFiles, formikProps, "b2b_image_desktop") }
        label={ "Imagen Desktop" }
        imageFile={ formikProps.values.b2b_image_desktop_upload || formikProps.values.b2b_image_desktop_preview  }
        onDelete={ () => props.handleImageRemove(formikProps, "b2b_image_desktop") }
      />
      
      <ImageDropZone
        onDrop={ (_dropFiles, acceptedFiles, _rejectedFiles) => props.handleImageDrop(acceptedFiles, formikProps, "b2b_image_mobile") }
        label={ "Imagen Mobile" }
        imageFile={ formikProps.values.b2b_image_mobile_upload || formikProps.values.b2b_image_mobile_preview  }
        onDelete={ () => props.handleImageRemove(formikProps, "b2b_image_mobile") }
      />
    </FormLayout>
  )
};

BannerB2BForm.propTypes = propTypes;
BannerB2BForm.defaultProps = defaultProps;

export default BannerB2BForm;            